<template>
  <main>
    <div class="content" id="botoes-servicos" v-if="sistema_vue == ''">
      <div class="row justify-content-md-center">
        <div class="col-md-8 row">
          <h1>Solicitação de serviços</h1>
          <p>
            <br />Estão disponíveis para solicitação apenas os serviços para os quais você está autorizado.
            Para solicitar algum serviço não disponível,
            <a href="https://prefeitura.unicamp.br/solicitantes-das-unidades-e-orgaos/">confira os usuários
              autorizados na sua Unidade/Órgão</a>.
          <ul>
            <li>Para inclusão ou alteração de usuários, o dirigente da Unidade/Órgão deve acessar o 
                <a href="https://sistemas.prefeitura.unicamp.br/apps/cadastro_solicitante/">sistema
                de cadastro no HUB.</a></li>
            <li>Para informação sobre os serviços prestados pela Prefeitura,
              <a href=" https://www.prefeitura.unicamp.br/produto/servicos/" target="_blank">clique aqui.</a>
            </li>
            <li>Em caso de dúvidas, escreva para <a href="mailto:falepref@unicamp.br">falepref@unicamp.br</a></li>
          </ul>
          </p>
        </div>
      </div>

      <!-- GRADE AUTOMÁTICA (montada por colunas a partir de índices) -->
      <div class="row justify-content-md-center">
        <div v-for="(col, cIndex) in colunas" :key="cIndex" class="col-md-auto">
          <div v-for="(serv, sIndex) in col" :key="`${serv.indice ?? sIndex}`" class="text-center">
            <img :src="require(`@/assets/img/${serv.img}`)" :class="serv.disabled
              ? 'disabled-img'
              : (servicos[serv.key]?.acesso ? 'enabled-img' : 'disabled-img')"
              @click="!serv.disabled && executar(serv)" alt="" />
            <br /><br />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { inject } from "vue";
import * as constants from '@/constants';

export default {
  name: "InterfaceCentralizada",
  data() {
    return {
      // estado dos serviços (permissões e urls)
      servicos: {
        os_dm: { acesso: false, url_base: constants.URL_DM },
        os_dm_onet: { acesso: false, url_base: constants.URL_DM_ONET },
        os_dma: { acesso: false, url_base: constants.URL_DMA },
        os_dae: { acesso: false, url_base: constants.URL_DAE },
        os_unitransp: { acesso: false, url_base: constants.URL_UNITRANSP },
        solicitacao_transporte: { acesso: true, url_base: constants.URL_SOLICITACAO_TRANSPORTE },
        cad_fretados: { acesso: true, url_base: constants.URL_CAD_FRETADOS },
        eventos: { acesso: true, url_base: constants.URL_EVENTOS },
        ssr: { acesso: true, url_base: constants.URL_SSR },
        taxi: { acesso: false, url_base: constants.URL_TAXI },
        buffet: { acesso: false, url_base: constants.URL_BUFFET },
        os_rp: { acesso: false, url_base: constants.URL_DM_RP },
      },

      matricula: '',
      nome: '',
      sise: '',
      token: '',
      sistema_vue: '',

      // número de colunas a exibir (mantenha em 5 para reproduzir seu layout atual)
      colCount: 5,

      // lista única de serviços: cada item pode ter `indice` para ordenação,
      // `key` para permissões, `acao` e `arg` para executar ação, ou `disabled: true`
      servicosLista: [
        // coloque aqui seus itens com o campo `indice` para definir a ordem exata
        { indice: 10, img: "areas-verdes.png", key: "os_dma", acao: "abrirServico", arg: "os_dma" },
        { indice: 20, img: "buffet.png", key:"buffet", acao: "abrirBuffet" },
        { indice: 30, img: "cadastro-condutores.png", key: "os_unitransp", acao: "abrirServico", arg: "solicitacao_transporte" },
        { indice: 40, img: "carro-executivo.png", key: "os_unitransp", acao: "abrirServico", arg: "solicitacao_transporte" },
        { indice: 50, img: "coleta-seletiva.png", key: "os_dma", acao: "abrirServico", arg: "os_dma" },
        { indice: 60, img: "pragas.png", key: "os_dma", acao: "abrirServico", arg: "os_dma" },
        { indice: 70, img: "cadastro-fretado.png", key: "cad_fretados", acao: "abrirServico", arg: "cad_fretados" },
        { indice: 80, img: "guia-vidente.png", disabled: true },
        { indice: 90, img: "limpeza-predial.png", key: "os_dma", acao: "abrirServico", arg: "os_dma" },
        { indice: 100, img: "limpeza-urbana.png", key: "os_dma", acao: "abrirServico", arg: "os_dma" },
        { indice: 110, img: "manut-frota.png", disabled: true },
        { indice: 120, img: "manutencao-predial.png", key: "os_dm", acao: "abrirServico", arg: "os_dm_onet" },
        { indice: 130, img: "manutencao-urbana.png", key: "os_dm", acao: "abrirServico", arg: "os_dm_onet" },
        { indice: 140, img: "monitoramento-animal.png", key: "os_dma", acao: "abrirServico", arg: "os_dma" },
        { indice: 150, img: "passagem-aerea.png", disabled: true },
        { indice: 160, img: "refeicao-evento.png", key: "ssr", acao: "abrirServico", arg: "ssr" },
        { indice: 170, img: "refeicao-visitante.png", key: "ssr", acao: "abrirServico", arg: "ssr" },
        { indice: 175, img: "revitalizacao-predial.png", key: "os_rp", acao: "abrirServico", arg: "os_rp" },
        { indice: 180, img: "saneamento.png", key: "os_dae", acao: "abrirServico", arg: "os_dae" },
        { indice: 190, img: "sinalizacao.png", key: "os_dm", acao: "abrirServico", arg: "os_dm" },
        { indice: 200, img: "evento.png", key: "eventos", acao: "abrirServico", arg: "eventos" },
        { indice: 210, img: "energia.png", key: "os_dae", acao: "abrirServico", arg: "os_dae" },
        { indice: 220, img: "taxi.png", key: "os_unitransp", acao: "abrirServico", arg: "taxi" },
        { indice: 230, img: "transp-carga.png", key: "os_unitransp", acao: "abrirServico", arg: "solicitacao_transporte" },
        { indice: 240, img: "transp-grupo.png", key: "os_unitransp", acao: "abrirServico", arg: "solicitacao_transporte" },
        { indice: 250, img: "vale-transporte.png", key: "cad_fretados", acao: "abrirServico", arg: "cad_fretados" },
      ],
    };
  },

  setup() {
    const cryptoJs = inject("cryptojs");
    return { cryptoJs };
  },

  computed: {
    // monta as colunas de forma que a leitura siga row-major:
    // itens com indices 1..N são colocados na primeira linha (colCount colunas),
    // depois  N+1..2N na segunda linha, etc.
    colunas() {
      const sorted = [...this.servicosLista].sort((a, b) => (a.indice ?? 0) - (b.indice ?? 0));
      const colCount = this.colCount;
      if (colCount <= 0) return [sorted];

      // dividir em linhas (cada linha tem até colCount itens)
      const rows = [];
      for (let i = 0; i < sorted.length; i += colCount) {
        rows.push(sorted.slice(i, i + colCount));
      }

      // transformamos linhas em colunas mantendo o alinhamento:
      const cols = Array.from({ length: colCount }, () => []);
      for (let r = 0; r < rows.length; r++) {
        for (let c = 0; c < colCount; c++) {
          const item = rows[r][c];
          if (item) cols[c].push(item);
        }
      }

      // remover colunas vazias no final (caso existam)
      return cols.filter(col => col.length > 0);
    },
  },

  mounted() {
    // popula dados do keycloak e inicia verificações
    this.matricula = this.$keycloak?.tokenParsed?.matricula ?? '';
    this.sise = this.$keycloak?.tokenParsed?.preferred_username ?? '';
    this.nome = this.$keycloak?.tokenParsed?.given_name ?? '';
    this.token = this.gerarToken();
    this.verificaAcessos();
  },

  methods: {
    // executa a ação configurada no item
    executar(serv) {
      if (!serv) return;
      if (serv.acao === "abrirServico") this.abrirServico(serv.arg);
      else if (serv.acao === "abrirBuffet") this.abrirBuffet(); // buffet é um serviço interno ao interface centralizada
                                                                // por isso não utiliza abrirServico e sim abrirBuffet
    },

    // verifica acessos de forma sequencial (melhora controle e evita sobrecarga)
    async verificaAcessos() {
      try {
        const keys = ['buffet', 'os_unitransp', 'os_dae', 'os_dma', 'os_dm', 'os_rp'];
        for (const k of keys) {
          // só chama verificaServico se existir a configuração para o key
          if (this.servicos[k]) await this.verificaServico(k);
        }
      } catch (err) {
        console.error(`[verificaAcessos] ${err.message}`);
      }
    },

    async verificaServico(servico) {
      try {
        const cfg = this.servicos[servico];
        if (!cfg || !cfg.url_base) return;
        const url = `${cfg.url_base}json_user.php?t=${this.token}&u=${this.matricula}&s=${this.sise}`;
        const response = await this.$axios.get(url);
        if (response.status === 200 && response.data === 'OK') {
          this.servicos[servico].acesso = true;
          // regras específicas 
          if (servico === 'os_unitransp') this.servicos.taxi.acesso = true;
          if (servico === 'os_dm') this.servicos.os_dm_onet.acesso = true;
        }
      } catch (error) {
        console.error(`[verificaServico] ${servico}: ${error.message}`);
      }
    },

    abrirServico(servico) {
      const cfg = this.servicos[servico];
      if (!cfg) return;
      if (cfg.acesso) window.open(cfg.url_base, '_blank');
    },

    gerarToken() {
      try {
        const d = new Date();
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        const seed = `${day}/${month}/${year}`;
        const t = "info-2024-usr-os";
        return this.cryptoJs.MD5(seed + t).toString();
      } catch (e) {
        console.error(`[gerarToken] ${e.message}`);
        
        return '';
      }
    },

    // função específica para redirecionamento a um serviço interno
    abrirBuffet() {
      this.$router.push("/buffet/");
    },
  },
};
</script>

<style src="@/assets/css/style.css" />
